import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { AutoplayControl } from "appworks/ui/controls/standard/button/autoplay-control";
import { ControlFactory } from "../control-factory";

export class AutoplayControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (layer.getFlexiButton("autoplay")) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new AutoplayControl(layer.getFlexiButton("autoplay")) ];
    }
}
